import { render } from "./PatternItem.vue?vue&type=template&id=52161b6d"
import script from "./PatternItem.vue?vue&type=script&lang=js"
export * from "./PatternItem.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__